<script lang="ts">
	import __ from '$lib/stores/TranslationStore';
	import ArticleCard from './ArticleCard.svelte';
	import ArrowRight from '$lib/assets/images/icons/arrow-right-dark.svg?component';

	export let title: string = '';
	export let articles: any[];
	export let contentClass: string = '';
	let className: string = '';
	export { className as class };
	export let seeMoreUrl: string = '';

	let article: any = null;
</script>

<div class={className}>
	{#if title}
		<slot name="header" {title}>
			<header class="flex py-4">
				<h3 class="text-caption">{title}</h3>
				<a href={seeMoreUrl} class="ml-auto flex items-center gap-x-2 text-primary">
					<p class="hidden text-sm uppercase md:block">{$__('Ver tudo')}</p>
					<ArrowRight class="fill-primary" />
				</a>
			</header>
		</slot>
	{/if}
	<div class={`grid ${contentClass || 'grid-cols-1 gap-8 md:grid-cols-2'}`}>
		{#each articles as article, index}
			{#if $$slots.first && index === 0}
				<slot name="first" {article}>
					<ArticleCard {article} />
				</slot>
			{:else if $$slots.last && index === articles?.length - 1}
				<slot name="last" {article}>
					<ArticleCard {article} />
				</slot>
			{:else}
				<slot {article}>
					<ArticleCard {article} />
				</slot>
			{/if}
		{/each}
	</div>
</div>
